// His bag: what he carries, in nine places.
//
// Sam, 3 Nov: "Perhaps he needs a carrying interface, when you click on Pino - it shows a popup like a minecraft
// inventory - and shows what he is carrying, and he has a certain amount of slots - this could be a good user
// interaction." It was eight places and his beak that morning; that afternoon, "do you think we need to differentiate
// between his beak and his bag? I think perhaps it could just be whats in his bag maybe?", and then "yes merge them".
//
// This half is the part the site and the town both read, so the pop-up, the gift button and the town's cap can never
// disagree: how many places, what can be given and how often, and what each of the bag's moves looks like on him and in
// his diary. What the moves do is the town's (sim-server/src/world/things/bag.js).

/** Places in the bag: the eight and the beak they were, merged. What shows over his head is the newest thing in it. */
export const BAG_SLOTS = 9

/**
 * The roost of his first shelf, nest_rest: where everything he kept at home was before the shelves came in (3 Nov), and
 * where a thing of his at home on no shelf still is, drawn by the open container (components/three/world/
 * BoughtThings.jsx). Which roosts have a shelf at all is the blend's (lib/world/shelves.js).
 */
export const HOME_NEST = 'nest_rest'

/**
 * What a visitor can give him from the pop-up. Free, and capped like the deeds (Sam, 3 Nov: "Free and capped").
 *
 * Each is one of the old shop's foods with its build fixed, so it lands as a thing the town already knows how to draw
 * (lib/items/parts.js), wear and spoil (sim-server/src/world/Items.js). Every one still feeds him less than the free
 * food in town, which is the rule the shop was built on.
 */
export const GIFTS = [
  { id: 'chips', itemId: 'chips', name: 'some chips', spec: { side: 'fries', on: 'none' }, built: 'Side: fries' },
  { id: 'glazed', itemId: 'doughnut', name: 'a glazed doughnut', spec: { kind: 'glazed' }, built: 'Kind: glazed' },
  { id: 'pink', itemId: 'doughnut', name: 'a pink doughnut', spec: { kind: 'pink' }, built: 'Kind: pink' },
  { id: 'strawberry', itemId: 'icecream', name: 'a strawberry ice cream', spec: { kind: 'strawberry' }, built: 'Kind: strawberry' },
  { id: 'tuna', itemId: 'sardines', name: 'a tin of tuna', spec: { kind: 'tuna' }, built: 'Kind: tuna' },
  { id: 'tea', itemId: 'thermos', name: 'a cup of tea', spec: { fill: 'tea', lid: 'lid' }, built: 'Fill: tea' },
  { id: 'cookie', itemId: 'cake', name: 'a cookie with a candle in it', spec: { base: 'cookie', top: ['candle'] }, built: 'Base: cookie' },
]

export function giftById(id) {
  return GIFTS.find((g) => g.id === id) || null
}

/** One gift a person a day, and no more than this many lying about for him at once, so the ground never fills. */
export const GIFTS_PER_DAY = 1
export const GIFTS_ON_THE_GROUND = 3

/**
 * The bag's moves as they look: the clip he plays (one of BIRD_CLIPS until Sam's pick-up and carry land), the
 * words his diary puts beside the moment, and what the activity feed in the corner says he is doing
 * (components/ui/ChatFeed.jsx; without it the feed printed the move's own name, "hold", 3 Nov).
 */
export const BAG_MOVES = {
  put_away: { clip: 'Rummage', diary: 'put away', feed: 'putting things away' },
  take_out: { clip: 'Rummage', diary: 'took out', feed: 'getting something out' },
  pick_up: { clip: 'Rummage', diary: 'picked up', feed: 'picking something up' },
}
